import {DataModel} from "../form/DataModel.js";

export const mezok = [
  {
    id: 'Gyártmány',
    label: 'Gyártó',
    input: {
      type: 'select',
      label: 'Gyártó',
      options: [ '- Gyártó' ],
      autocomplete: 'on',
      required: true,
    }
  },
  {
    id: 'Modell',
    label: 'Modell',
    input: {
      type: 'select',
      label: 'Modell',
      options: [ '- Modell' ],
      autocomplete: 'on',
      required: true
    }
  },
  {
    id: 'Ccm',
    label: 'Ccm',
    input: {
      type: 'select',
      label: 'Ccm',
      options: [ '- Ccm' ],
      autocomplete: 'on',
      required: true
    }
  },
  {
    id: 'Típus',
    label: 'Típus | Teljesítmény | Év',
    input: {
      type: 'select',
      label: 'Típus | Teljesítmény | Év',
      options: [ '- Típus | Teljesítmény | Év' ],
      autocomplete: 'on',
      required: true
    }
  },
];

export const MotorAkkuModel = new DataModel(mezok);
